import { InputAlertMessage } from '../../components/Form/InputAlertMessage';
import { TextInput } from '../../components/Form/TextInput';
import { AddressFields, Errors } from '../../components/pages/EditOrderPage';
import { useTranslation } from '../../i18n/i18n';

export const AddressModalInput = ({
	name,
	value,
	errors,
	onChange,
	onBlur,
}: {
	name: AddressFields;
	value: string;
	errors: Errors;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
	onBlur?: (e: {
		target: {
			name: string;
			value: string;
		};
	}) => void;
}) => {
	const t = useTranslation().form;

	return (
		<div>
			<TextInput
				id={name}
				placeholder={t[name]}
				value={value}
				onChange={onChange}
				isValid={errors[name]?.valid}
				onBlur={onBlur}
			/>
			{!errors[name]?.valid && <InputAlertMessage type="error" message={errors[name]?.message || ''} />}
		</div>
	);
};
